// DEMO-1d (2026-09-25) — the thin bar across the top of every page on the
// demo site, so nobody mistakes it for the real CRM. Renders nothing on
// production (see lib/demo.js). Same fixed-bar + body padding approach as
// ImpersonationBanner, and it steps aside while that banner is showing.
import { useEffect } from "react";
import { FlaskConical } from "lucide-react";
import { useDemoInfo } from "@/lib/demo";
import { isImpersonating } from "@/lib/impersonation";

const DEMO_BANNER_HEIGHT_PX = 28;

export default function DemoBanner() {
  const info = useDemoInfo();
  const impersonating = isImpersonating();
  const show = !!info && !impersonating;

  useEffect(() => {
    if (!show) return undefined;
    const prev = document.body.style.paddingTop;
    document.body.style.paddingTop = `${DEMO_BANNER_HEIGHT_PX}px`;
    return () => {
      document.body.style.paddingTop = prev;
    };
  }, [show]);

  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="demo-banner"
      style={{ height: DEMO_BANNER_HEIGHT_PX, lineHeight: `${DEMO_BANNER_HEIGHT_PX}px` }}
      className="fixed top-0 left-0 right-0 z-[999] bg-[#bd9a59] text-[#021d49] text-xs px-4 flex items-center justify-center gap-2 shadow-sm"
    >
      <FlaskConical className="w-3.5 h-3.5 shrink-0" />
      <span className="truncate">
        <span className="font-semibold">Demo</span>
        <span className="hidden sm:inline"> · fictional data, nothing is sent</span>
        {" "}· resets nightly
      </span>
    </div>
  );
}
